import React, { useEffect, memo, useReducer, useRef, useState } from "react";
import { ConfigResolverMap, useDrag } from "@use-gesture/react";
import { useSpring, animated } from "@react-spring/web";
import { clamp } from "lodash";
import { useMeasure } from "react-use";



import { useApp } from "store/AppStore";

import { Root, Slides } from "./ProductSlider.styled.js";
import Slide from "./Slide";
import { arraySlice } from "three/src/animation/AnimationUtils.js";

function areEqual(prev, next) {
  return (
    prev.isPortrait === next.isPortrait &&
    prev.isShort === next.isShort &&
    prev.selectedProductIndex === next.selectedProductIndex &&
    prev.style.transform === next.style.transform
  );
}

/*
//Paramètres orbits de base
const CameraController = () => {
  const { camera, gl } = useThree();
  useEffect(() => {
    const controls = new OrbitControls(camera, gl.domElement);
    controls.minDistance = 3;
    controls.maxDistance = 20;
    controls.enableDamping = true;
    controls.enabled = false;
    camera.position.z = 4;
    camera.position.y = 0;
    camera.position.x = 0;
    camera.panSpeed = 0;
    camera.lookAt(controls.target);

    controls.enabled = true;

    //Fonction d'update des positions similaire a ThreeJS (fonctionne avec l'aos) variable : aos"DIRECTION"

    function simpleupdate() {
      setTimeout(() => {
        switch (window.utalk.playcanva) {
          case 0:
            if (
              window.utalk.aosZ + window.utalk.aosY + window.utalk.aosX !=
              0
            ) {
              controls.enabled = false;
              camera.position.x += window.utalk.aosX;
              camera.position.y += window.utalk.aosY;
              camera.position.z = 4 + window.utalk.aosZ / 25;
              camera.lookAt(controls.target);
              controls.enabled = true;
            }

            break;

          case 1:
            controls.enabled = false;
            camera.position.z += 0.01;
            camera.position.x += 0.1;
            camera.lookAt(controls.target);
            controls.enabled = true;

            break;
        }

        simpleupdate();
      }, 10);
    }
    //simpleupdate();

    controls.enabled = true;
    return () => {
      controls.dispose();
    };
  }, [camera, gl]);
  return null;
};
*/


/*
function Model({ url, ...props }) {
  const { scene } = useGLTF("VOYAGER_HOLDER.glb")
  return <primitive object={scene} {...props} />
}
*/

//Paramètres orbits controls.
/*
 <boxGeometry attach="geometry" args={[3, 2, 1]} />
 <meshPhongMaterial attach="material" color="purple" />
  <spotLight intensity={0.3} position={[5, 10, 50]} />
        <Environment preset="city" />
      <ContactShadows frames={1} scale={5} position={[0, -1, 0]} far={1} blur={5} opacity={0.5} color="#204080" />
      <ambientLight />
*/

/*export const presetsObj = {
  sunset: 'venice/venice_sunset_1k.hdr',
  dawn: 'kiara/kiara_1_dawn_1k.hdr',
  night: 'dikhololo/dikhololo_night_1k.hdr',
  warehouse: 'empty-wharehouse/empty_warehouse_01_1k.hdr',
  forest: 'forrest-slope/forest_slope_1k.hdr',
  apartment: 'lebombo/lebombo_1k.hdr',
  studio: 'studio-small-3/studio_small_03_1k.hdr',
  city: 'potsdamer-platz/potsdamer_platz_1k.hdr',
  park: 'rooitou/rooitou_park_1k.hdr',
  lobby: 'st-fagans/st_fagans_interior_1k.hdr',
}

      shadow-camera-far={60}
      shadow-camera-left={-40}
      shadow-camera-right={40}
      shadow-camera-top={40}
      shadow-camera-bottom={-40}

      width: 100vw;
    height: 100vh;
    display: block;

*/


const ProductSlider = memo(
  ({
    style,
    products,
    selectedProductIndex,
    setSelectedProduct,
    isShort,
    isPortrait,
  }) => {
    const [ref, { width }] = useMeasure();
    const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);

    const [{ x, cursor }, api] = useSpring(() => ({
      x: selectedProductIndex * width,
      cursor: "grab",
    }));

    const bind = useDrag(
      ({ dragging, movement: [mx], swipe: [swipeX], cancel }) => {
        if (isPortrait) {
          if (swipeX) {
            //console.log(swipeX);
            const nextSlideIndex = clamp(
              selectedProductIndex - swipeX,
              0,
              products.length - 1
            );
            //console.log(nextSlideIndex);
            setSelectedProduct(nextSlideIndex);
            // cancel()
          }
        } else {
          if (dragging) {
            //console.log("dragging");
            //console.log(swipeX);
            //console.log(dragging);
            if (Math.abs(mx) > width / 2) {
              const nextSlideIndex = clamp(
                selectedProductIndex - Math.sign(mx),
                0,
                products.length - 1
              );
              //console.log(selectedProductIndex);
              setSelectedProduct(nextSlideIndex);
              api.start({ x: -(nextSlideIndex * width - mx), cursor: "grab" });
              cancel();
            } else {
              api.start({
                x: -(selectedProductIndex * width - mx),
                cursor: "grabbing",
              });
            }
          } else {
            api.start({ x: -(selectedProductIndex * width), cursor: "grab" });
          }
        }
      },
      { axis: "x" }
    );

    useEffect(() => {
      api.start({ x: -(selectedProductIndex * width) });
    }, [selectedProductIndex, width, api]);

    //console.log("triggered");

    //return le canva remplis si plus grand ou égale a 8
    window.utalk.selprodind = selectedProductIndex;
//<Root id="timelineslider" className="clicktrought" style={{position:"absolute"}} isShort={isShort} isPortrait={isPortrait}>
    return (
      <>
       

        <Root
          id="timelineslider"
          className={window.utalk.selprodind >= 8 ? "clicktrought" : ""}
          style={window.utalk.selprodind >= 8 ? {} : style }
          isShort={isShort}
          isPortrait={isPortrait}
        >
          <Slides
            className={window.utalk.selprodind >= 8 ? "" : "enabled"}
            ref={ref}
            {...bind()}
            style={window.utalk.selprodind >= 8 ? { x, cursor, pointerEvents:"none"  }: { x, cursor }}
          >
            {products.map((product, id) => (
              <Slide
              style={window.utalk.selprodind >= 8 ? {  pointerEvents:"none"  }: ""}
                key={product.id}
                {...product}
                selected={selectedProductIndex === id}
                visible={window.utalk.selprodind >= 8 ? 0 : Math.abs(selectedProductIndex - id) < 2}
              ></Slide>
            ))}
          </Slides>
        </Root>
      </>
    );


  },
  areEqual
);

const WrappedSlider = (props) => {
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  var {
    products,
    selectedProductIndex,
    setSelectedProduct,
    isShort,
    isPortrait,
    shouldupdate,
  } = useApp();

  useEffect(() =>{
    //console.log("SET CONTROLABLE" )
    window.utalk.iscontrolable = true;
  },[])
  /*
  setInterval(() => {
    window.utalk.iscontrolable = true;
  }, 5000);
*/


  return (
    <ProductSlider
      {...props}
      {...{
        products,
        selectedProductIndex,
        setSelectedProduct,
        isShort,
        isPortrait,
      }}
    ></ProductSlider>
  );
};

export default animated(WrappedSlider);
